import {createReducer} from 'redux-create-reducer';
import * as Immutable from 'immutable';
import {Keys, Actions} from '../constants';
import {standardLoadingReducerFactory} from './reducer-utils';

export default createReducer(
    {},
    Object.assign(
        {},
        standardLoadingReducerFactory(
            Actions.GET_ASSIGNEES,
            Keys.StoreSliceData.ASSIGNEES,
        ),
        {
            [Actions.CURRENT_WORK_SESSION_UPDATED]:(assigneesState, action) => {
                // synchronize current session assignees
                const currentWorkSession = action.payload[[Keys.StoreSliceData.CURRENT_WORK_SESSION]];
                const assigneesInSession = currentWorkSession.get(Keys.CurrentWorkSession.ASSIGNEES, Immutable.Set());
                return assigneesState.updateIn([Keys.StoreSliceData.ASSIGNEES], (assigneeMap) => {
                    return assigneeMap.map((assignee, id) => {
                        return assignee.set(Keys.Assignee.IN_WORK_SESSION, assigneesInSession.contains(id));
                    })
                })
            },
            [Actions.ITEMS_UPDATED]:(assigneesState, action) => {
                // synchronize items
                const assignees = assigneesState.get(Keys.StoreSliceData.ASSIGNEES, Immutable.Map());
                const items = action.payload[[Keys.StoreSliceData.ITEMS]];
                const itemsPerRetoucher={};
                const itemsPerQc={};
                assignees.forEach((assignee, id) => {itemsPerRetoucher[id]=[]; itemsPerQc[id]=[]});
                items.forEach((item, id) => {
                    const assigneeId = item.get(Keys.Item.ASSIGNEE_ID, null);
                    const qcAssigneeId = item.get(Keys.Item.QC_ASSIGNEE_ID, null);
                    if( assigneeId && itemsPerRetoucher[assigneeId]) {
                        itemsPerRetoucher[assigneeId].push(id);
                    }
                    if( qcAssigneeId && itemsPerQc[qcAssigneeId]) {
                        itemsPerQc[qcAssigneeId].push(id);
                    }
                });
                // TODO: Should we keep it in a separate structure instead?
                return assigneesState.updateIn([Keys.StoreSliceData.ASSIGNEES], (assigneeMap) => {
                    return assigneeMap.map((assignee, id) => {
                        return assignee.set(Keys.Assignee.ITEMS, Immutable.Set(itemsPerRetoucher[id])).
                        set(Keys.Assignee.QC_ITEMS, Immutable.Set(itemsPerQc[id]));
                    })
                })
            }
        }
    )
);



// WEBPACK FOOTER //
// ./src/model/reducers/assignee-reducer.js